// Captures ?ref=<code> once and keeps it for 30 days so attribution survives
// even if the visitor lands on a marketing page (e.g. the price-floor calculator)
// before eventually registering.
export function captureReferralSource() {
  const fromUrl = new URLSearchParams(window.location.search).get("ref");
  if (fromUrl) {
    document.cookie = `ref_source=${encodeURIComponent(fromUrl)}; path=/; max-age=${60 * 60 * 24 * 30}`;
    return fromUrl;
  }
  const match = document.cookie.match(/(?:^|; )ref_source=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}
